import { Navigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/useMediaQuery";

export function LandingRedirect() {
  return <Navigate to={useIsMobile() ? "/companion/today" : "/dashboard"} replace />;
}
